<template>
    <div class="hero hero-wavy is-fullheight is-relative is-light-grey huge-pb">
        <!-- Hero -->
        <div id="main-hero" class="hero-body">
            <div class="container has-text-centered">
                <div class="columns is-vcentered pt-50 pb-50">
                    <div class="column is-6 is-offset-3 z-index-2">
                        <!-- Recover form -->
                        <div id="recover-card" class="animated preFadeInLeft fadeInLeft">
                            <div class="flex-card clean-login-card">
                                <h2 class="has-text-centered text-bold title is-3">Reset Password</h2>
                                <form>
                                    <div class="control-material is-secondary">
                                        <b-field label="Email"
                                label-position="inside">
                                    <b-input type="email"
                                        v-model="email">
                                    </b-input>
                                </b-field>
                                    </div>
    
                                    <div class="mt-20">
                                        <button @click="resetPassword" class="button button-cta btn-align secondary-btn rounded is-fullwidth raised no-lh">Reset Password</button>
                                    </div>
                                </form>
                            </div>
    
                            <p class="has-text-centered pt-20 pb-20">
                                <router-link :to="{name: 'Login'}">  
                                    Back to login 
                                </router-link>
                            </p>
                        </div>
                        <!-- /Recover form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /Hero image -->
    </div>
</template>

<script>
import firebase from '@/firebase';
export default {
    name: 'login',
    data() {
        return {
            email: ''
        }
    },
    methods: {
        resetPassword() {            
            firebase.auth().sendPasswordResetEmail(this.email).then(function() {
            console.log('email sent')
            }).catch(function(error) {
            console.log(error)
            });
        }
    }
}
</script>

<style scoped>
  /* "scoped" attribute limit the CSS to this component only */

  .login {
      margin-top: 40px;
  }

  input {
      margin: 10px 0;
      width: 20%;
      padding: 15px;
  }

  button {
      margin-top: 20px;
      width: 10%;
      cursor: pointer;
  }

  p {
      margin-top: 40px;
      font-size: 13px;
  }

  p a {
      text-decoration: underline;
      cursor: pointer;
  }

  .social-button {
      width: 75px;
      background: white;
      padding: 10px;
      border-radius: 100%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      outline: 0;
      border: 0;
  }

  .social-button:active {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .social-button img {
      width: 100%;
  }
</style>